module.exports = __webpack_public_path__ + "static/media/button-wizard-4.f8b9ac3b.png";